__turbopack_context__.v({
  "italic": "LocalHeroExplanation-module__jcWNgG__italic",
  "localHeroExplanation": "LocalHeroExplanation-module__jcWNgG__localHeroExplanation",
  "localHeroExplanationItem": "LocalHeroExplanation-module__jcWNgG__localHeroExplanationItem",
  "localHeroExplanationTitle": "LocalHeroExplanation-module__jcWNgG__localHeroExplanationTitle",
  "localHeroExplanationsList": "LocalHeroExplanation-module__jcWNgG__localHeroExplanationsList",
});
